import { defineComponent as _defineComponent } from 'vue'
import { EntityTypeProperty, PropertyDataType } from '@/entities/entityTypeProperty';
  import { EntityItemPropertyValueForm } from '@/entities/entityItemPropertyValue';
  import { OptionValue } from '@/entities/optionSet';
  import { ValidationError } from '@/entities/validation';
  import { PageSubtitle } from '@/ui/components';
  import TextPropertyInput from './TextPropertyInput.vue';
  import DropdownPropertyInput from './DropdownPropertyInput.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EntityItemPropertiesSection',
  props: {
    properties: {
      type: Array as () => EntityTypeProperty[],
      required: true,
    },
    propertyValues: {
      type: Array as () => EntityItemPropertyValueForm[],
      required: true,
    },
    errors: {
      type: Array as () => ValidationError[],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;

  

  

  const getComponentForProperty = (property: EntityTypeProperty) => {
    return property.dataType === PropertyDataType.Text ? TextPropertyInput : DropdownPropertyInput;
  };

  const getKeyForProperty = (property: EntityTypeProperty) => {
    return property.id ? `property-${property.id}` : `property-new-${Math.random()}`;
  };

  const getModelValue = (property: EntityTypeProperty) => {
    if (!property.id) {
      return null;
    }

    return getValueForProperty(property.id);
  };

  const handleInput = (property: EntityTypeProperty, value: string | number | number[] | null) => {
    if (property.id) {
      updatePropertyValue(property.id, value);
    }
  };

  const getValueForProperty = (propertyId: number) => {
    const property = props.properties.find(p => p.id === propertyId);
    const propertyValue = props.propertyValues.find(pv => pv.entityTypePropertyId === propertyId);

    if (!property || !propertyValue) {
      return property?.dataType === PropertyDataType.Text ? null : [];
    }

    if (property.dataType === PropertyDataType.Text) {
      return propertyValue.valueText;
    }

    if (Array.isArray(propertyValue.optionValueIds)) {
      return propertyValue.optionValueIds;
    }

    if (Array.isArray(propertyValue.optionValues)) {
      return propertyValue.optionValues
        .map((ov: OptionValue) => ov && ov.id)
        .filter((id): id is number => typeof id === 'number');
    }

    return [];
  };

  const updatePropertyValue = (propertyId: number, value: string | number[] | null) => {
    const updatedValues = [...props.propertyValues];
    const existingIndex = updatedValues.findIndex(pv => pv.entityTypePropertyId === propertyId);

    const property = props.properties.find(p => p.id === propertyId);
    if (!property) {
      return;
    }

    const propertyValue: EntityItemPropertyValueForm = {
      entityTypePropertyId: propertyId,
      valueText: property.dataType === PropertyDataType.Text ? (value as string | null) : null,
      optionValueIds: property.dataType === PropertyDataType.Dropdown ? (value as number[]) : undefined,
      optionValues: undefined,
    };

    if (existingIndex >= 0) {
      updatedValues[existingIndex] = propertyValue;
    } else {
      updatedValues.push(propertyValue);
    }

    emit('input', updatedValues);
  };

return { __sfc: true,props, emit, getComponentForProperty, getKeyForProperty, getModelValue, handleInput, getValueForProperty, updatePropertyValue, PageSubtitle }
}

})